const ConfigurationError = require('./errors/ConfigurationError');
const DuplicateError = require('./errors/DuplicateError');
const MismatchError = require('./errors/MismatchError');
const NotFoundError = require('./errors/NotFoundError');
const InUseError = require('./errors/InUseError');
const PageRangeError = require('./errors/PageRangeError');
const PageSizeError = require('./errors/PageSizeError');
const RemoveReferenceError = require('./errors/RemoveReferenceError');
const MissingAuthorizationError = require('./errors/MissingAuthorizationError');
const UnauthorizedError = require('./errors/UnauthorizedError');
const InvalidTokenError = require('./errors/InvalidTokenError');
const AntennaConfigurationError = require('./errors/AntennaConfigurationError');
const DeviceUnknownError = require('./errors/DeviceUnknownError');
const ConflictError = require('./errors/ConflictError');
const ValidationError = require('./errors/ValidationError');
const LicenseDepletedError = require('./errors/LicenseDepletedError');
const TimeoutError = require('./errors/TimeoutError');

module.exports = {
    AntennaConfigurationError,
    ConfigurationError,
    ConflictError,
    DeviceUnknownError,
    DuplicateError,
    InUseError,
    InvalidTokenError,
    LicenseDepletedError,
    MismatchError,
    MissingAuthorizationError,
    NotFoundError,
    PageRangeError,
    PageSizeError,
    RemoveReferenceError,
    TimeoutError,
    UnauthorizedError,
    ValidationError,
};
